import apiClient, { CustomFetchError } from "@/api/openApiClient";
import { ApiError } from "@/bapi-client/errors";
import { AssetRequest, AssetResponse } from "@telegraphio/bapi-types";

export interface AssetsApi {
  getAssetHistory(customerId: string, equipmentId: string, request: AssetRequest): Promise<AssetResponse>;
}

export const assetsApi: AssetsApi = {
  async getAssetHistory(customerId: string, equipmentId: string, request: AssetRequest): Promise<AssetResponse> {
    const { data, error, response } = await apiClient.POST("/assets/{customer_id}/{equipment_id}", {
      params: {
        path: {
          customer_id: customerId,
          equipment_id: equipmentId,
        },
      },
      body: { ...request },
    });

    if (error) {
      const errorMessage = Array.isArray(error)
        ? error.map((e) => e.msg).join(", ")
        : (error as CustomFetchError)?.message || "Failed to get asset history";

      throw ApiError.create(errorMessage, response?.status, error);
    }

    return data;
  },
};
